
import React from "react";
import Slider from "react-slick";
import { motion, AnimatePresence } from "framer-motion";
import "../../styles/HeroCarousel.css";

// Slides (images already imported by user)
import img1 from "../../assets/hero/hero1.jpg";
import img2 from "../../assets/hero/hero2.jpg";
import img3 from "../../assets/hero/hero3.png";
import img4 from "../../assets/divine/6.png";
import img5 from "../../assets/hero/hero5.jpeg";
import img6 from "../../assets/hero/hero6.jpg";
import img7 from "../../assets/hero/hero7.jpg";
import img8 from "../../assets/hero/hero8.jpg";

const slides = [
  { image: img1, titleTop: "Crafting Excellence in Every Piece", titleBottom: "crafted for every lifestyle", cta: "View Our Work" },
  { image: img2, titleTop: "Design Meets Precision", titleBottom: "crafted for every lifestyle", cta: "View Our Work" },
  { image: img3, titleTop: "Luxury Interiors for Modern Living", titleBottom: "crafted for every lifestyle", cta: "View Our Work" },
  { image: img4, titleTop: "Handcrafted With Care", titleBottom: "crafted for every lifestyle", cta: "View Our Work" },
  { image: img5, titleTop: "Your Vision, Our Creation", titleBottom: "crafted for every lifestyle", cta: "View Our Work" },
  { image: img6, titleTop: "Timeless Wooden Craft", titleBottom: "crafted for every lifestyle", cta: "View Our Work" },
  { image: img7, titleTop: "Built to Last", titleBottom: "crafted for every lifestyle", cta: "View Our Work" },
  { image: img8, titleTop: "Transforming Spaces", titleBottom: "crafted for every lifestyle", cta: "View Our Work" },
];


const HeroCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4500,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    pauseOnHover: false,
    adaptiveHeight: false,
    accessibility: true,
    waitForAnimate: true,
    appendDots: (dots) => <ul className="hc-dots">{dots}</ul>,
    customPaging: () => <button className="hc-dot" aria-label="Go to slide" />,
  };

  return (
    <section id="home" className="hero-carousel" style={{ minHeight: "100vh", padding: "100px 20px" }} aria-label="Featured">
      <Slider {...settings}>
        {slides.map((s, i) => (
          <div key={i} className="hero-slide" role="group" aria-roledescription="slide">
            <img src={s.image} className="hero-image" alt="Showcase interior" />
            <div className="overlay">
              <AnimatePresence mode="wait">
                <motion.div
                  key={`k-${i}`}
                  initial={{ opacity: 0, y: 18, scale: 0.98 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -14, scale: 0.98 }}
                  transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
                >
                  {/* Small capsule badge */}
                  <span className="hc-badge">{s.badge}</span>

                  {/* Big stacked title + subhead */}
                  <h1 className="overlay-title">{s.titleTop}</h1>
                  <p className="overlay-sub">{s.titleBottom}</p>

                  {/* CTA group: pill + circular arrow */}
                  <div className="buttons" role="group" aria-label="Primary actions">
                    <a href="#portfolio" className="primary" aria-label="View our work">
                      {s.cta}
                    </a>
                    <button
                      className="circle-arrow"
                      aria-label="Next"
                      onClick={() => {
                        const gallery = document.getElementById("portfolio");
                        if (gallery) {
                          gallery.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                      }}
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path
                          d="M8 5l7 7-7 7"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>

                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* White rounded notch container for dots, positioned like the reference */}
            {/* <div className="dots-fab" aria-hidden="true" /> */}
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroCarousel;
